import { cn } from '@nextui-org/react';
import React from 'react';

const ProductPrice = ({
  discount,
  price,
  basePrice,
}: {
  discount: string | null;
  price: string;
  basePrice: string | null;
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between">
        <div className="flex flex-wrap items-center">
          <p
            className={cn(
              'mr-2 mb-0 text-2xl',
              discount ? 'text-green-500' : 'text-black dark:text-white'
            )}
          >
            <span className="sr-only">Price:</span>
            USD {price}
          </p>
          {discount && (
            <p className="text-sm text-gray-500">
              <span className="sr-only">Original Price:</span>
              <span className="line-through">{basePrice}</span>
            </p>
          )}
        </div>
      </div>

      {discount && (
        <div className="mb-2">
          <p className="text-xl text-green-500">
            {discount} off sale for a limited time
            {/* TODO: the next x hours */}
          </p>
        </div>
      )}
    </div>
  );
};

export default ProductPrice;
